<template>
    <div class="fill-height of-y d-flex flex-column">
        <div class="flex-grow-1 of-y d-flex">
            <div class="flex-equal flex-grow-1 fill-height of-y flex-column">
                <div class="d-flex align-center">
                    <v-card-title class="flex-grow-1 flex-equal py-2">
                        Summary
                    </v-card-title>
                    <div class="flex-grow-1 flex-equal pr-2">
                        <v-text-field
                                v-model="search"
                                prepend-icon="mdi-magnify"
                                label="Search"
                                single-line
                                hide-details
                                class="pa-0 ma-0"
                        ></v-text-field>
                    </div>
                </div>

                <v-data-table
                        :search="search"
                        dense
                        fixed-header
                        height="100%"
                        class="flex-grow-1 of-y"
                        hide-default-footer
                        :headers="summaryHeaders"
                        :items="summary"
                        :options="{itemsPerPage: summary.length}"
                ></v-data-table>
            </div>
            <div class="flex-equal flex-grow-1 fill-height of-y d-flex flex-column">
                <div class="d-flex align-center">
                    <v-card-title class="flex-grow-1 flex-equal py-2">
                        Detail
                    </v-card-title>
                    <div class="flex-grow-1 flex-equal pr-2" style="min-width: 150px">
                        <v-text-field
                                v-model="searchDetail"
                                prepend-icon="mdi-magnify"
                                label="Search"
                                single-line
                                hide-details
                                class="pa-0 ma-0"
                        ></v-text-field>
                    </div>
                    <div class="pr-1">
                        <v-btn
                                :disabled="false"
                                @click="exportReportData"
                                color="primary"
                                small
                                :loading="exportingData"
                        >
                            Export
                        </v-btn>
                    </div>
                </div>
                <v-data-table
                        :search="searchDetail"
                        dense
                        fixed-header
                        height="100%"
                        class="flex-grow-1 of-y"
                        hide-default-footer
                        :headers="headers"
                        :items="detail"
                        :options="{itemsPerPage: detail.length}"
                ></v-data-table>
            </div>

        </div>


    </div>
</template>

<script>

import {mapGetters} from "vuex";
import {format} from "date-fns";

export default {
    components: {},
    props: {
        selectedFarm: Number,
        selectedDate: Date
    },
    data() {
        return {
            search: null,
            searchDetail: null,
            summaryHeaders: [
                {text: "Farm", value: "farmName"},
                {text: "Device", value: "deviceName"},
                {text: "Total Bins", value: "totalBins"},
            ],
            headers: [
                {text: "Captured", value: "timeStr"},
                {text: "Bin ID", value: "binCode"},
                {text: "Farm", value: "farmName"},
                // {text: "Device", value: "deviceName"},
            ],
            data: {
                summary: [],
                detail: [],
            },
            exportingData: false
        }
    },
    watch: {
        selectedFarm: {
            immediate: true,
            handler() {
                this.getIntakeData()
            }
        },
        selectedDate(val) {
            if (val) {
                this.getIntakeData()
            }
        }
    },
    methods: {
        async getIntakeData() {
            try {
                this.loading = true;
                this.data = await this.$newReq(
                        'POST',
                        `reports/binIntake`,
                        {
                            date: this.selectedDate,
                            farms: this.selectedFarm ? [this.selectedFarm] : this.availableFarmIDs,
                        },
                )
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError();
            } finally {
                this.loading = false
            }
        },
        exportReportData() {
            this.exportingData = true;
            console.log(this.farmsRef)
            this.$newReqDownloadFile(
                    'POST',
                    `reports/binIntake/export`,
                    {
                        start: this.selectedDate,
                        farms: this.selectedFarm ? [this.selectedFarm] : this.availableFarmIDs,
                    },
                    `Bin Intake Report ${format(this.selectedDate, 'yyyy-MM-dd')}.xlsx`
            )
                    .then(data => {
                        console.log(data)
                    })
                    .catch(e => {
                        console.log(e)
                        this.$snack.netWorkError();
                    })
                    .finally(() => {
                        this.exportingData = false
                    })
        }
    },
    computed: {
        ...mapGetters(['farmsRef', 'availableFarms']),
        availableFarmIDs() {
            return (this.availableFarms.length ? this.availableFarms : this.farms).map((farm) => farm.id)
        },
        farm() {
            return this.selectedFarm ? this.farmsRef[this.selectedFarm] : null
        },
        summary() {
            return [...this.data.summary].sort((a,b) => a.farmName > b.farmName ? 1 : -1)
        },
        detail() {
            return [...this.data.detail].sort((a,b) => a.timeStr > b.timeStr ? 1 : -1)
        }
        // rows() {
        //     return this.data.map(row => {
        //         return {
        //             farmID: row.farm.id,
        //             farm: row.farm.description,
        //             employee: row.emp.fullName,
        //             empCode: row.emp.empCode,
        //             clockIn: row.clockInStr,
        //             lastAction: row.lastActionStr,
        //             binUnits: row.binUnits,
        //             piecework: row.pieceWorkStr,
        //             pWUnits: row.pieceWorkUnits,
        //             hours: row.hours,
        //         }
        //     }).filter((row) => this.selectedFarm ? row.farmID === this.selectedFarm : true)
        // }
    },
}
</script>

<style scoped>

</style>